import { createAction } from 'redux-act';

import { Domain } from './types';

const NAME = 'domain-redirect/';

export const handleDomainRedirect = createAction<{ oldDomain: Domain }>(`${NAME}handle domain redirect`);
export const rejectDomainRedirect = createAction(`${NAME}reject domain redirect`);
